import faker from 'faker';

export const amount = 10;

export default () => ({
    email: faker.internet.email(),
    name: faker.name.firstName(),
});